export default "__VITE_ASSET__iaA$0yyB__"